'use client';
import { SWR_FETCHER_IDS } from '@roll-web/constants';
import { useContext, useMemo } from 'react';
import useSWR from 'swr';
import { apiClient } from '~/lib/apiClient';
import { RootContext } from '~/store';
import { OrderPrize } from '~/types/resources/orderPrize';

type UseGachaIdPrize = {
  gacha_id: string;
  orderPrizes: OrderPrize[];
  loading: boolean;
  error: Error;
  mutate: () => void;
};

export const useGachaIdPrizes = (gacha_id: string): UseGachaIdPrize => {
  const { token, loggedInState } = useContext(RootContext);
  const swrKey = useMemo(
    () => ({
      fetcherId: SWR_FETCHER_IDS.GET_PRIZES_BY_GACHA_ID,
      gachaId: gacha_id,
      ...(loggedInState == 'loggedIn' && { authorization: token?.token }),
    }),
    [gacha_id, loggedInState, token?.token]
  );
  const { data, error, mutate } = useSWR(swrKey, ({ gachaId, authorization }) =>
    getPrizesByGachaId({
      gachaId,
      authorization,
    })
  );

  return {
    gacha_id,
    orderPrizes: data?.prizes ?? [],
    loading: !data && !error,
    error: error,
    mutate,
  };
};

export type GetPrizesByGachaIdInput = {
  gachaId: string;
  authorization?: string;
};
const getPrizesByGachaId = async (
  input: GetPrizesByGachaIdInput
): Promise<{ prizes: OrderPrize[] }> => {
  const { gachaId, authorization } = input;
  const datas = await apiClient.v1.gachas._gachaId(gachaId).prizes.$get({
    headers: {
      ...(authorization != undefined && {
        Authorization: `Bearer ${authorization}`,
      }),
    },
  });
  return datas;
};
